var ui_templates = require("ui-templates");
var Core        = ui_templates.Core;

class SidebarPackageGeneratorRefImage extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'imageUrl': ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__sidebar__package__generator__ref__image js-editor__sidebar__package__generator__ref__image">
                <% if(imageUrl) { %>
                    <img src="<%= imageUrl %>">
                <% } %>
            </div>
        `;

        super.render();
    }
}

module.exports = SidebarPackageGeneratorRefImage;